"use strict";
// import { NlcQAModel } from "../model/NlcQAModel"
Object.defineProperty(exports, "__esModule", { value: true });
// import { Common } from "./../../../common/common"
// import { Common } from "./../common/common"
var Common = /** @class */ (function () {
    function Common() {
    }
    /**
     * 範囲内の乱数を取得
     * @param from 以上
     * @param to 以下
     */
    Common.getRandNum = function (from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
    };
    /// 文字列が空(Null or "" or undefined)か調べる
    Common.isNullOrEmpty = function (text) {
        return text === null || text === undefined || text === "";
    };
    /**
     * 引数をフォーマットして文字列化する default "yyyy/MM/dd"
     * @param date 日付型あるいは文字列・数字型8桁
     * @param format default "yyyy/MM/dd"
     * @example Common.DateFormat(new Date(), "yyyy-MM-dd")
     */
    Common.DateFormat = function (date, format) {
        if (format === void 0) { format = "yyyy/MM/dd"; }
        if (!date) {
            return "";
        }
        var target;
        // フォーマット対象の文字列への変換処理
        if (typeof date === "number") {
            var dateText = date.toString();
            target = new Date(dateText.substring(0, 4) + "/" + dateText.substring(4, 6) + "/" + dateText.substring(6, 8));
        }
        else if (typeof date === "string") {
            target = new Date(date.substring(0, 4) + "/" + date.substring(4, 6) + "/" + date.substring(6, 8));
        }
        else if (date instanceof Date) {
            target = date;
        }
        else {
            return date;
        }
        var result = format;
        Common.dateFormatter.forEach(function (formatter) {
            result = formatter(result, target);
        });
        // for (const func in Common.dateFormatter) {
        //   if (Common.dateFormatter.hasOwnProperty(func)) {
        //     result = result.replace(func, Common.dateFormatter[func](target))
        //   }
        // }
        return result;
    };
    /**
     * 日付差分を取得(日数)
     * @param date1
     * @param date2
     */
    Common.dateDiff = function (date1, date2) {
        return (date2.getTime() - date1.getTime()) / 86400000;
    };
    /**
     * 指定した分nヶ月加算する
     * @param date 加算する日付 値が変わるので注意
     * @param value valueヶ月 加算 マイナス許可
     */
    Common.AddMonth = function (date, value) {
        // 計算前日付
        var preDate = date.getDate();
        date.setMonth(date.getMonth() + value);
        if (date.getDate() !== preDate) {
            // 計算後日付が一致しない場合、前月月末指定
            date.setDate(0);
        }
        return date;
    };
    /**
     * 指定した日加算する
     * @param date 加算する日付 値が変わるので注意
     * @param value valueヶ月 加算 マイナス許可
     */
    Common.AddDate = function (date, value) {
        // 計算前日付
        date.setDate(date.getDate() + value);
        return date;
    };
    /** timezone考慮 */
    Common.getNowDate = function (now) {
        if (now === void 0) { now = new Date(); }
        // -9h = -540
        var offset = new Date().getTimezoneOffset() / 60;
        now.setHours(now.getHours() - offset);
        return now;
    };
    /**
     * 3桁カンマ区切り
     * @param price
     */
    Common.priceFormat = function (price) {
        if (typeof price === "number") {
            return price.toLocaleString();
        }
        else {
            return Number(price).toLocaleString();
        }
    };
    Common.dateFormatter = [
        // format長が大きいものから定義すること
        function (formatText, date) { return formatText.replace("hh", ("0" + date.getHours()).slice(-2)); },
        function (formatText, date) { return formatText.replace("h", date.getHours() + ""); },
        function (formatText, date) { return formatText.replace("mm", ("0" + date.getMinutes()).slice(-2)); },
        function (formatText, date) { return formatText.replace("m", date.getMinutes() + ""); },
        function (formatText, date) { return formatText.replace("dd", ("0" + date.getDate()).slice(-2)); },
        function (formatText, date) { return formatText.replace("d", date.getDate() + ""); },
        function (formatText, date) { return formatText.replace("ss", ("0" + date.getSeconds()).slice(-2)); },
        function (formatText, date) { return formatText.replace("s", date.getSeconds() + ""); },
        function (formatText, date) { return formatText.replace("yyyy", date.getFullYear() + ""); },
        function (formatText, date) { return formatText.replace("yy", (date.getFullYear() + "").slice(-2)); },
        function (formatText, date) {
            return formatText.replace("t", date.getDate() <= 3 ? ["st", "nd", "rd"][date.getDate() - 1] : "th");
        },
        function (formatText, date) {
            return formatText.replace("w", ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()]);
        },
        function (formatText, date) { return formatText.replace("MMMM", [
            "January", "February", "March", "April",
            "May", "June", "July", "August", "September",
            "October", "November", "December"
        ][date.getMonth()]); },
        function (formatText, date) { return formatText.replace("MMM", [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jly", "Aug", "Spt", "Oct", "Nov", "Dec"
        ][date.getMonth()]); },
        function (formatText, date) { return formatText.replace("MM", ("0" + (date.getMonth() + 1)).slice(-2)); },
        function (formatText, date) { return formatText.replace("M", (date.getMonth() + 1) + ""); },
    ];
    return Common;
}());
exports.Common = Common;
//# sourceMappingURL=common.js.map